import { render } from "./Create-page.vue?vue&type=template&id=9933b93e&scoped=true"
import script from "./Create-page.vue?vue&type=script&lang=js"
export * from "./Create-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=9933b93e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9933b93e"]])

export default __exports__